export const sortItemsAsc = (arr, field) => {
  return arr.sort((a, b) => {
    const aValue = a[field] ?? '';
    const bValue = b[field] ?? '';
    return aValue.localeCompare(bValue);
  });
};